module.exports = __webpack_public_path__ + "static/img/剪纸1.3e04c2d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/decorativePainting/imgs/剪纸1.svg
// module id = cbWy
// module chunks = 2